import React, {useState, useEffect} from 'react';
import CollapseButton from '../../../utilities/CollapseButton/CollapseButton';
import {constructPurchasedPrice, checkSectionValid} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';
import {generalSubscriber} from '../../Page/TransactionSummaryPage/Shared/Constants';

const AdditionalCharges = ({data, context, additionalCharges, currentSubscriber}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [allCharges, setCharges] = useState(<div />);
  const [showComponent, setShowComponent] = useState(checkSectionValid(additionalCharges));

  useEffect(() => {
    if (showComponent || currentSubscriber !== undefined) {
      if (currentSubscriber === undefined) {
        setCharges(setDetails(additionalCharges.charges));
      } else {
        var additionalChargesBySubscriber = additionalCharges.charges.filter((charge) => charge.subscriber === currentSubscriber);
        setShowComponent(true);
        setCharges(setDetails(additionalChargesBySubscriber));
        if (additionalChargesBySubscriber.length === 0) {
          setShowComponent(false);
        }
      }
    }
  }, [additionalCharges, currentSubscriber]);

  const cardTitle = data.additionalChargesTopic.value === '' ? 'חיובים חד פעמיים' : data.additionalChargesTopic.value;

  return (
    showComponent && (
      <div className='block-frame p-2'>
        <CollapseButton cardTitle={cardTitle} setIsOpen={setIsOpen} isOpen={isOpen} />
        {isOpen && (
          <div className='block-frame__container'>
            <div className='equipment-summary'>{allCharges}</div>
          </div>
        )}
      </div>
    )
  );
};

function setDetails(additionalCharges) {
  return (
    <React.Fragment>
      <hr />
      {additionalCharges.map((charge, idx) => {
        return (
          <div className='block-frame__list-info' key={idx.toString() + charge.name}>
            <div className='block-frame__row block-frame__row--2'>
              <label>{charge.name}</label>
              {constructPurchasedPrice(charge.price, charge.numOfInstallments, '')}
            </div>
            {charge.isBanLvl && <span>*חיוב בגין דמי מעבר ברמת לקוח לחשבון חיוב</span>}
          </div>
        );
      })}
    </React.Fragment>
  );
}

export default AdditionalCharges;
